import { render, staticRenderFns } from "./preview-drag.vue?vue&type=template&id=383b33d0&scoped=true"
import script from "./preview-drag.vue?vue&type=script&lang=js"
export * from "./preview-drag.vue?vue&type=script&lang=js"
import style0 from "./preview-drag.vue?vue&type=style&index=0&id=383b33d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b33d0",
  null
  
)

export default component.exports